module.exports = __webpack_public_path__ + "img/portrait-065.1ed133c6.jpg";